module.exports = __webpack_public_path__ + "img/cp-05.ecd8496c.png";